import StoneArchiveConfirmDialog from './StoneArchiveConfirmDialog'

export default StoneArchiveConfirmDialog
